const WEBHOOK_LIST = {
  LIST_PAGE_HEADER_TITLE: 'List of created webhooks',
  LIST_PAGE_HEADER_DESCRIPTION:
    'In this section, you can see the list of addresses for which you activated the webhook function:',
  LIST_PAGE_HEADER_BTN_LABEL: 'Add new webhook',
  LIST_PAGE_TABLE_COL_1_HEAD: 'Website',
  LIST_PAGE_TABLE_COL_2_HEAD: 'Webhook address',
  LIST_PAGE_TABLE_COL_3_HEAD: 'Events',
  LIST_PAGE_TABLE_COL_4_HEAD: 'Edit',
  LIST_PAGE_NO_WEBHOOK: 'No webhook added yet',

  LIST_PAGE_EVENT_MSG: 'New Message',
  LIST_PAGE_EVENT_CONV: 'New Conversation',
  LIST_PAGE_SWITCH_ACTIVE: 'Active',
  LIST_PAGE_SWITCH_INACTIVE: 'Inactive',
};

export default WEBHOOK_LIST;
